import React from 'react'
import Section from '../components/section'
import Stories from '../components//stories'

export default ({ title, stories, background }) => (
  <Section
    title={title}
    mainContent={() => <Stories data={stories} />}
    contentAlignment="left"
    background={background}
  />
)
